<template>
  <main class="my-5">
    <MDBContainer>
      <MDBRow class="mb-5">
        <MDBCol md="5">
          <div class="bg-image hover-overlay shadow-1-strong rounded">
            <img
              src="https://mdbootstrap.com/img/new/fluid/city/113.jpg"
              class="w-100"
            />
            <a href="#!">
              <div
                class="mask"
                style="background-color: rgba(251, 251, 251, 0.2)"
              ></div>
            </a>
          </div>
        </MDBCol>
        <MDBCol md="7">
          <h1 class="mb-4">Heading of the page</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi
            porro aliquam ipsum! Commodi fugit, magni dignissimos itaque,
            expedita suscipit perferendis necessitatibus ea eligendi ducimus,
            quos id consequatur repudiandae dolorem sequi.
          </p>
          <hr class="my-4" />
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi
            porro aliquam ipsum! Commodi fugit, magni dignissimos itaque,
            expedita suscipit perferendis necessitatibus ea eligendi ducimus,
            quos id consequatur repudiandae dolorem sequi.
          </p>
          <MDBBtn color="primary" class="me-3">Primary</MDBBtn>
          <MDBBtn outline="primary">
            <MDBIcon icon="shopping-cart" class="me-2" iconStyle="fas" />
            Buy Now</MDBBtn
          >
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol md="4">
          <MDBCard>
            <a v-mdb-ripple="{ color: 'light' }">
              <MDBCardImg
                src="https://mdbootstrap.com/img/new/standard/nature/111.jpg"
                top
                alt="..."
              />
            </a>
            <MDBCardBody>
              <MDBCardTitle>Card title</MDBCardTitle>
              <MDBCardText>
                Some quick example text to build on the card title and make up
                the bulk of the card's content.
              </MDBCardText>
              <MDBBtn tag="a" href="#!" color="primary">Button</MDBBtn>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        <MDBCol md="4">
          <MDBCard>
            <a v-mdb-ripple="{ color: 'light' }">
              <MDBCardImg
                src="https://mdbootstrap.com/img/new/standard/nature/112.jpg"
                top
                alt="..."
              />
            </a>
            <MDBCardBody>
              <MDBCardTitle>Card title</MDBCardTitle>
              <MDBCardText>
                Some quick example text to build on the card title and make up
                the bulk of the card's content.
              </MDBCardText>
              <MDBBtn tag="a" href="#!" color="primary">Button</MDBBtn>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        <MDBCol md="4">
          <MDBCard>
            <a v-mdb-ripple="{ color: 'light' }">
              <MDBCardImg
                src="https://mdbootstrap.com/img/new/standard/nature/113.jpg"
                top
                alt="..."
              />
            </a>
            <MDBCardBody>
              <MDBCardTitle>Card title</MDBCardTitle>
              <MDBCardText>
                Some quick example text to build on the card title and make up
                the bulk of the card's content.
              </MDBCardText>
              <MDBBtn tag="a" href="#!" color="primary">Button</MDBBtn>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  </main>
</template>
<script>
import {
  MDBCol,
  MDBRow,
  MDBContainer,
  MDBBtn,
  MDBIcon,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardImg,
  mdbRipple,
} from "mdb-vue-ui-kit";

export default {
  components: {
    MDBCol,
    MDBRow,
    MDBContainer,
    MDBBtn,
    MDBIcon,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBCardImg,
  },
  directives: {
    mdbRipple,
  },
};
</script>